export class Contact
{
	public contactId: string;
	public contactJurisdictionId: string;
	public contactFirstName: string;
	public contactLastName: string;
	public contactEmailOrBookingNumber: string;
	public contactType: string;
	public contactCredits: number;
	public createdInstantMillis: number;
	public hasInmatePortal: boolean;
	public hasBeenReleased: boolean;
	// field for adding
	public isNew: boolean = false;
}

export class PotentialContact
{
	public userId: string;
	public username: string;
	public firstName: string;
	public lastName: string;
	public fullName: string;
	public hasBeenAdded: boolean;
}

export class ContactResponse
{
	public userId: string;
	public contactUserId: string;
	public createdInstant: Date;
}

export class ContactCreated
{
	public alreadyExisted: boolean;
	public email: string;
	public contactUserId: string;
}
